// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1wM7z","errorLogs":"styles_errorLogs__Tqn-O"};